import { MeetingAttendee } from './meeting-attendee.model';
import { Recurring } from './recurring.model';

export class ViewMeetingsDetail {
    adjourned: Boolean;
    agendaExists: Boolean;
    agendaTitle: string;
    attendees: Array<MeetingAttendee>;
    colorHexCode: string;
    description: string;
    endDateTime: string;
    endTime: string;
    location: string;
    meetingId: Number;
    meetingRecurringId: Number;
    meetingTitle: string;
    meetingTypeBackgroundColor: string;
    meetingTypeDescription: string;
    meetingTypeId: number;
    minutesMeetingExists: Boolean;
    recurring: Recurring;
    recurringId: number;
    recurringType: string;
    startDateTime: string;
    startTime: string;
    staticEndDate: string;
    templates: Array<any>;
    type: string;
    agendaStatus: number;
    base64ThumbnailsString: any;
    meetingAgendaId: number;
    base64ThumbnailsStringForMinutes: any;
    minutesStatus: number;
    minutesId: number;
    newMeetingDate: string;
    newMeetingTime: string;
    publicAgendaSummery: string;
    publicAgendaPacket: string;
    publicMinutes: string;
    uploadMinutesVideo: boolean;
    uploadMinutesVideoURL: string;
    videoId: string;
    videoStatus: string;
    locationUploadUrl: string;
    thumbnailOfVideo: string;
    canceled: boolean;
    importAgenda: boolean;
    importMinutes: boolean;
    meetingTypeName: string;
    agendaOCRedContent: string;
    minutesOCRedContent: string;
    agendaPacketEnabled: boolean;
    minutesPacketEnabled: boolean;
    agendaSnippet: string;
    minutesSnippet: string;
    packetFileSizeThreshold: number;
    packetFileSizeExceeded: boolean;

    constructor() {
        this.adjourned = false;
        this.agendaExists = false;
        this.agendaTitle = '';
        this.attendees = [];
        this.colorHexCode = '';
        this.description = '';
        this.endDateTime = '';
        this.endTime = '';
        this.location = '';
        this.meetingId = 0;
        this.meetingRecurringId = 0;
        this.meetingTitle = '';
        this.meetingTypeBackgroundColor = '';
        this.meetingTypeDescription = '';
        this.meetingTypeId = 0;
        this.minutesMeetingExists = false;
        this.recurring = new Recurring();
        this.recurringId = 0;
        this.recurringType = '';
        this.startDateTime = '';
        this.startTime = '';
        this.staticEndDate = '';
        this.templates = [];
        this.type = '';
        this.agendaStatus = 0;
        this.base64ThumbnailsString = '';
        this.meetingAgendaId = 0;
        this.newMeetingDate = '';
        this.newMeetingTime = '';
        this.uploadMinutesVideo = false;
        this.uploadMinutesVideoURL = '';
        this.meetingTypeName = '';
        this.agendaOCRedContent = '';
        this.minutesOCRedContent = '';
        this.agendaPacketEnabled = true;
        this.minutesPacketEnabled = true;
        this.agendaSnippet = '';
        this.minutesSnippet = '';
        this.packetFileSizeThreshold = 300;
        this.packetFileSizeExceeded = false;
    }
}

export class MinutesWorkflow {
    type: number;
    minApprovers: number;
    maxApprovers: number;
    approvers: Array<any>;
    approverList: Array<any>;
    isSequence: boolean;
    isStatus: boolean;
    oldApprovers: Array<any>;
    oldMaxApprovers: number;
    oldMinApprovers: number;
    oldType: number;

    constructor() {
        this.type = 0;
        this.minApprovers = 0;
        this.maxApprovers = 0;
        this.approvers = [];
        this.approverList = [];
        this.isSequence = true;
        this.isStatus = true;
        this.oldMaxApprovers = 0;
        this.oldMinApprovers = 0;
        this.oldType = 0;
    }
}

export class ViewMinutesDetail {
    minutesMeetingNumber: string;
    title: string;
    meetingId: Number;
    status: number;
    meetingTypeId: Number;
    id: number | null;
    deleted: boolean;
    byteArrayPDF: string;
    imported: boolean;
    meetingTitle: string;
    meetingDate: Date;
    meetingTypeTitle: string;
    minutesMeetingApproval: MinutesWorkflow;
    approvalCount: number;
    comments: string;
    workflowUserAction: boolean;

    constructor() {
        this.minutesMeetingNumber = '';
        this.title = '';
        this.meetingId = 0;
        this.status = 0;
        this.meetingTypeId = 0;
        this.id = null;
        this.deleted = false;
        this.byteArrayPDF = '';
        this.imported = false;
        this.meetingTitle = '';
        this.meetingTypeTitle = '';
        this.workflowUserAction = false;
        this.comments = '';
        this.minutesMeetingApproval = new MinutesWorkflow();

    }
}

export class SubscriptionModel {
    email: string;
    meetingTypeTitle: string;
    recurringId: number;
    meetingTypeId: number;
    notifyForMeetingType: boolean;
    agendaPosted: boolean;
    minutesPosted: boolean;
    videoPosted: boolean;
    constructor() {
        this.email = '';
        this.meetingTypeTitle = '';
        this.recurringId = 0;
        this.meetingTypeId = 0;
        this.notifyForMeetingType = true;
        this.agendaPosted = false;
        this.minutesPosted = false;
        this.videoPosted = false;
    }
}

export class MessageResponseModel {
    message: string;
}